
const Setting = {
	appDomain: { api: process.env.NODE_ENV==="production"?'https://virtual.ciif-expo.com/':'/api/', },
	// appDomain: { api: process.env.NODE_ENV==="production" ? 'https://zggbh.bjjfsd.com.cn/' : '/api/', },
	// appDomain: { api: process.env.NODE_ENV==="production"?'https://zggbh.bjjfsd.com/':'/api/', },
	uploadUrl: '/adminApi.php/Tool/setUploadPath'
}

export default Setting
